export default class ProductCount {
    public productId: number;
    public productGuid: string;
    public quantity: number;
    public customData: CartItemCustomData;

    constructor(productId: number, productGuid: string, quantity: number, customData: CartItemCustomData = null) {
        this.productId = productId;
        this.productGuid = productGuid;
        this.quantity = quantity;
        this.customData = customData;
    }
}

export interface CartItemCustomData {
    customDataText: string;
    customData: string;
}
